import React from "react";

const CloseSVG = ({ action, color }) => {
  return (
    <svg
      onClick={action}
      style={{ cursor: "pointer" }}
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="31" height="31" rx="4" fill="none" />
      <path
        d="M20.7518 11.6187C20.8444 11.5294 20.9182 11.4225 20.969 11.3044C21.0199 11.1862 21.0466 11.0591 21.0478 10.9305C21.049 10.8019 21.0245 10.6743 20.9759 10.5552C20.9272 10.4361 20.8554 10.3279 20.7644 10.2369C20.6735 10.1459 20.5654 10.0739 20.4464 10.0252C20.3273 9.97641 20.1998 9.95183 20.0712 9.95289C19.9425 9.95395 19.8154 9.98061 19.6972 10.0313C19.579 10.082 19.472 10.1558 19.3826 10.2483L15.4999 14.1297L11.6184 10.2483C11.5297 10.1531 11.4228 10.0768 11.3039 10.0238C11.1851 9.97086 11.0568 9.94239 10.9268 9.94009C10.7967 9.9378 10.6675 9.96173 10.5469 10.0104C10.4262 10.0592 10.3166 10.1317 10.2247 10.2237C10.1327 10.3157 10.0601 10.4252 10.0114 10.5459C9.9627 10.6665 9.93877 10.7957 9.94107 10.9258C9.94336 11.0559 9.97183 11.1841 10.0248 11.303C10.0777 11.4218 10.1541 11.5288 10.2492 11.6174L14.1281 15.5002L10.2467 19.3816C10.0755 19.5653 9.98239 19.8082 9.98682 20.0592C9.99124 20.3101 10.0929 20.5496 10.2704 20.7271C10.4479 20.9046 10.6874 21.0062 10.9383 21.0107C11.1893 21.0151 11.4322 20.9219 11.6158 20.7508L15.4999 16.8694L19.3813 20.7521C19.565 20.9232 19.8079 21.0164 20.0588 21.012C20.3098 21.0075 20.5493 20.9059 20.7268 20.7284C20.9043 20.5509 21.0059 20.3114 21.0103 20.0604C21.0148 19.8095 20.9216 19.5666 20.7505 19.3829L16.8716 15.5002L20.7518 11.6187Z"
        fill={color ? color : "black"}
        fill-opacity="0.66"
      />
    </svg>
  );
};

export default CloseSVG;
